import { themedColor } from '@lemonade-hq/cdk';
import { css } from 'styled-components';

function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  border-radius: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  border-color: ",
        ";\n  box-shadow: 0 0 0 1px ",
        " inset;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  transition: box-shadow 0.1s;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  &::placeholder {\n    color: ",
        ";\n    text-transform: uppercase;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
var DEFAULT_BORDER_RADIUS = "5px";
var rounded = css(_templateObject(), DEFAULT_BORDER_RADIUS);
var borderHighlight = css(_templateObject1(), themedColor("primary"), themedColor("primary"));
var animatedHighlight = css(_templateObject2());
var styledPlaceholder = css(_templateObject3(), themedColor("metal"));

export { DEFAULT_BORDER_RADIUS, animatedHighlight, borderHighlight, rounded, styledPlaceholder };
